import React, { Component } from "react";
import Fullscreen from "react-full-screen";
import { Provider, Subscribe } from "unstated";
import { DndProvider } from "react-dnd-multi-backend";
import HTML5toTouch from "react-dnd-multi-backend/dist/esm/HTML5toTouch";

import StateContainer from "./state/StateContainer";
import ObjectWindow from "./components/ObjectWindow/ObjectWindow";
import Navbar from "./components/Navbar/Navbar";
import DirectionControls from "./components/DirectionControls/DirectionControls";
import MapView from "./components/MapView/MapView";
import Compass from "./components/Compass/Compass";
import Compare from "./pages/Compare/Compare";
import DisplayWrapper from "./components/DisplayWrapper/DisplayWrapper";
import DefaultButton from "./components/Buttons/DefaultButton/DefaultButton";
import CalibrationHelper from "./components/CalibrationHelper/CalibrationHelper";
import CustomButtonArray from "./components/Buttons/CustomButtonArray/CustomButtonArray";
import ShowApartment from "./pages/ShowApartment/ShowApartment";
import LoadingOverlay from "./pages/LoadingOverlay/LoadingOverlay";
import OrbViewSidebar from "./components/OrbViewSidebar/OrbViewSidebar";
import OrbView from "./components/OrbView/OrbView";
import LandscapeNotification from "./components/LandscapeNotification/LandscapeNotification";
import useScreenOrientation from "./hooks/useScreenOrientation";

import "./style/Label.css";
import "./style/App.css";

class App extends Component {
  /**
   * Used as a callback to get loading progress from a child component.
   * @param loadingValue Loading progress value
   */
  getLoadingProgress(loadingValue) {
    let canvas = document.getElementById("root");
    let event = new CustomEvent("updateLoadingProgress", {
      detail: {
        newValue: loadingValue,
      },
    });
    canvas.dispatchEvent(event);
  }

  shouldShowCanvas(state) {
    if (state.isApartmentInfoShown || state.isCompareShown) return 0;
    return 1;
  }

  render() {
    return (
      <DndProvider options={HTML5toTouch}>
        <OrbView />
        <LandscapeNotification />
        <Fullscreen
          enabled={this.props.unstated.state.isFullscreen}
          onChange={(isFullscreen) =>
            this.props.unstated.setFullscreen(isFullscreen)
          }
        >
          <div id="full-screenable-node" className={`full-screenable-node`}>
            {this.props.unstated.state.loadingProgress === 100 ? null : (
              <LoadingOverlay
                loadingProgress={this.props.unstated.state.loadingProgress}
                loadingClass={{
                  display: "block",
                  backgroundImage: `Url(${this.props.unstated.state.loadingScreen})`,
                }}
              />
            )}
            <canvas
              style={{
                // height: "100%",
                // width: "100%",
                opacity: this.shouldShowCanvas(this.props.unstated.state)
                  ? 1
                  : 0,
                pointerEvents: "none",
              }}
              id="my-canvas"
            />

            <Compare
              clientLogo={
                this.props.unstated.state.jsonData.skinEditor
                  ? this.props.unstated.state.jsonData.skinEditor.clientLogo
                  : null
              }
              allApartments={this.props.unstated.state.allApartments}
              isCompareShown={this.props.unstated.state.isCompareShown}
              activeCompareApratmentType={
                this.props.unstated.state.activeCompareApratmentType
              }
            />

            {this.props.unstated.state.isApartmentInfoShown && (
              <ShowApartment
                isApartment3DCanvasShown={
                  this.props.unstated.state.isApartment3DCanvasShown
                }
                apartmentClickedInfo={
                  this.props.unstated.state.apartmentClickedInfo
                }
              />
            )}

            <DisplayWrapper stayInDom={true} displayParameter="isMainMenuShown">
              <Navbar
                isMouseOnSideBar={this.props.unstated.state.isMouseOnSideBar}
                toggleMapOn={this.props.unstated.toggleMapOn.bind(this)}
              />
            </DisplayWrapper>

            {this.props.unstated.state.orbViews.length > 0 && (
              <OrbViewSidebar />
            )}

            {this.props.unstated.state.isMapShown ? <MapView /> : null}

            <DisplayWrapper displayParameter="isCompasShown">
              <Compass
                hotspotAngle={this.props.unstated.state.hotspotAngle}
                compassStartingAngle={
                  this.props.unstated.state.compassStartingAngle
                }
              />
            </DisplayWrapper>

            {this.props.unstated.state.loadingProgress !== 100 ? null : (
              <div>
                <DirectionControls />

                <CustomButtonArray />
                <DisplayWrapper displayParameter="isFullscreenButtonShown">
                  <DefaultButton
                    buttonClass="fullscreen-button"
                    buttonName="Fullscreen"
                  />
                </DisplayWrapper>
                {this.props.unstated.state.calibratorEnabled ? (
                  <CalibrationHelper />
                ) : null}
              </div>
            )}
          </div>

          <ObjectWindow
            loadingProgress={this.props.unstated.state.loadingProgress}
            waitForImage={this.props.unstated.state.waitForImage}
            currentState={this.props.unstated.state.currentState}
            currentRow={this.props.unstated.state.currentRow}
            currentColumn={this.props.unstated.state.currentColumn}
            currentFilter={this.props.unstated.state.currentFilter}
            currentQuadratureFilter={this.props.unstated.state.quadratureFilter}
            currentPricesFilter={this.props.unstated.state.priceFilter}
            currentTags={this.props.unstated.state.currentTags}
            maxColumns={this.props.unstated.state.maxColumns}
            currentHotspotColumn={
              this.props.unstated.state.currentHotspotColumn
            }
            rowsPerFloor={this.props.unstated.state.rowsPerState}
            hotspotAngle={this.props.unstated.state.hotspotAngle}
            cameraZoom={this.props.unstated.state.cameraZoom}
            cameraDistanceMultiplier={
              this.props.unstated.state.cameraDistanceMultiplier
            }
            hotspotScale={this.props.unstated.state.hotspotScale}
            calibratorEnabled={this.props.unstated.state.calibratorEnabled}
            isDragging={this.props.unstated.state.isDragging}
            labelIsHovered={this.props.unstated.state.labelIsHovered}
            isMapShown={this.props.unstated.state.isMapShown}
            isApartmentInfoShown={
              this.props.unstated.state.isApartmentInfoShown
            }
            isCompareShown={this.props.unstated.state.isCompareShown}
            isMouseOnSideBar={this.props.unstated.state.isMouseOnSideBar}
            projectJSON={this.props.unstated.state.jsonData}
            allApartments={this.props.unstated.state.allApartments}
            apartmentClickedInfo={
              this.props.unstated.state.apartmentClickedInfo
            }
            linkHotspots={this.props.unstated.state.linkHotspots}
            hotspotUnavailableColor={
              this.props.unstated.state.hotspotUnavailableColor
            }
            hotspots={this.props.unstated.state.hotspots}
            favouriteApartments={this.props.unstated.state.favouriteApartments}
            loaderImg={this.props.unstated.state.loaderImg}
            threeSixtyImageUrl={this.props.unstated.state.threeSixtyImageUrl}
            targetDefaultPosition={
              this.props.unstated.state.targetDefaultPosition
            }
            apartmentHoverSquare={
              this.props.unstated.state.apartmentHoverSquare
            }
            apartmentHoverTitle={this.props.unstated.state.apartmentHoverTitle}
            apartmentReservedColor={this.props.unstated.state.apartmentReservedColor}
            update={{
              getLoadingProgress: this.getLoadingProgress.bind(this),
            }}
          />
        </Fullscreen>
      </DndProvider>
    );
  }
}

const AppWithUnstated = (props) => {
  return (
    <Provider>
      <Subscribe to={[StateContainer]}>
        {(unstated) => <App {...props} unstated={unstated} />}
      </Subscribe>
    </Provider>
  );
};

export default AppWithUnstated;
